<template>
  <j-modal
    :width="750"
    :visible="visible"
    :mask="true"
    :fullscreen="izMobile"
    class="j-super-query-modal"
    style="top: 0%; max-height: 95%"
    :destroyOnClose="true"
    @cancel="handleCancel"
    @ok="handleOk"
    :footer="null"
  >
    <div slot="title">
      <span class="title">照片清单</span>
    </div>
    <a-card class="img-timeline-card">
      <a-spin tip="加载中..." :spinning="picLoading">
        <a-timeline style="overflow-y: auto; height: 550px">
          <a-timeline-item color="green" v-for="(item, index) in picData" :key="index">
            <p>{{ item.name }}</p>
            <div>
              <div
                style="width: 100px; display: inline-block"
                v-for="(pic, uIndex) in item.data"
                :key="uIndex"
              >
                <img
                  style="width: 100px; height: 100px; border: 1px solid #ccc; padding: 5px"
                  :src="getImgView(pic.faceUrl)"
                />
                <div v-if="userInfo().username === 'admin'" style="text-align: center">
                  {{ pic.emotion_dictText }}
                </div>
              </div>
            </div>
          </a-timeline-item>
        </a-timeline>
      </a-spin>
    </a-card>
  </j-modal>
</template>

<script>
import { getAction, postAction } from '@api/manage'
import { mapGetters } from 'vuex'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import moment from 'moment'

export default {
  name: 'ImgTimeLineModal',
  mixins: [JeecgListMixin],
  props: {
    title: {
      type: String,
      default: '情绪趋势分析',
    },
  },
  data() {
    return {
      visible: false,
      picLoading: false,
      param: {},
      picData: [],
      queryParam: {},
    }
  },
  computed: {
    izMobile() {
      return this.device === 'mobile'
    },
  },
  methods: {
    ...mapGetters(['userInfo']),
    show(data) {
      console.log(data)
      this.visible = true
      this.queryParam = {
        beginDate: data.beginDate,
        endDate: data.endDate,
        studentId: data.studentId,
      }
      this.showPic()
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    handleCancel() {
      this.close()
    },
    showPic() {
      this.picLoading = true
      this.isShowPic = !this.isShowPic
      this.param = JSON.parse(JSON.stringify(this.queryParam))
      //   this.param.studentId = studentId
      this.param.pageNo = 1
      this.param.pageSize = 200
      this.param.column = 'createTime'
      this.param.order = 'desc'
      this.param.beginDate = moment(this.param.beginDate).subtract(14, 'days').format('YYYY-MM-DD')

      getAction('/aigoes/studentFace/list', this.param).then((res) => {
        if (res.success) {
          this.picData = this.jsonArrayGroup(res.result.records)
        }
        this.picLoading = false
      })
    },
    jsonArrayGroup(arr) {
      var map = {},
        dest = []
      for (var i = 0; i < arr.length; i++) {
        var ai = arr[i]
        var key = ai.createTime.substring(0, 10)
        if (!map[key]) {
          dest.push({
            name: key,
            data: [ai],
          })
          map[key] = ai
        } else {
          for (var j = 0; j < dest.length; j++) {
            var dj = dest[j]
            if (dj.name == key) {
              dj.data.push(ai)
              break
            }
          }
        }
      }
      return dest
    },
    handleOk() {},
  },
}
</script>

<style lang="less" scoped>
.title {
  font-size: 15px;
  font-weight: bold;
  margin-right: 12px;
}
.img-timeline-card {
  max-height: 600px;
  overflow: hidden;
}
</style>
